import { isObjectEmpty } from ".";
import { StorageAccessor } from "../StorageAccesor/StorageAccesor";
import {
  FormDispatch,
  FormFields,
  FormReducer,
  FormStateType,
} from "./formTypes";
import { initialFormState } from "../Hooks/form";

export function clear(
  name: FormFields,
  dispatch: FormDispatch,
  setValue: (name: FormFields, value: any) => void
) {
  dispatch({
    type: FormReducer.clear,
    field: name,
  });

  const initialValue = initialFormState[name];
  setValue(name, initialValue ?? {});
}

export function onSubmit(goToNextStep: () => void, errors: any) {
  if (isObjectEmpty(errors)) {
    goToNextStep();
  }
}

export function setStorage(state: FormStateType) {
  const newStorage = state;
  const storage = new StorageAccessor();
  const oldStorage = storage.getItem();

  storage.setItem({ ...oldStorage, ...newStorage });
}

export function parseStateToStorageEntries(state: FormStateType) {
  const newStorage = Object.keys(state).reduce((acc: any, key: string) => {
    if (isObjectEmpty(state[key] || !state[key])) return acc;
    if (state[key].startTime != undefined && !state[key].id) {
      const appointment = {
        startTime: state[key].startTime,
        doctorId: state[key].doctorId,
        centerId: state[key].centerId,
      };
      acc[key] = appointment;
    } else {
      acc[key] = state[key].id;
    }
    return acc;
  }, {});

  return newStorage;
}

export function clickOutsideFunction(
  className: string,
  closeFunction: () => void,
  event: Event
) {
  if (event instanceof PointerEvent) {
    const test = event.target as unknown as HTMLElement;
    const isTargetTermsButton = test.classList.contains(className) ?? false;
    !isTargetTermsButton ? closeFunction() : null;
  } else if (event instanceof KeyboardEvent) {
    closeFunction();
  }
  return;
}
